import { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';
import { toast } from 'sonner';

export default function useHomeSlides() {
  const queryClient = useQueryClient();
  const [slides, setSlides] = useState([]);
  const [saving, setSaving] = useState(false);
  const { data = [], isLoading } = useQuery({
    queryKey: ['home-slides'],
    queryFn: () => base44.entities.HomeSlide.list('position', 3),
    refetchOnWindowFocus: false,
    staleTime: 0,
  });

  // Popola lo stato locale solo la prima volta: evita che un refetch
  // cancelli le modifiche non ancora salvate.
  useEffect(() => {
    setSlides((current) => current.length ? current : Array.from({ length: 3 }, (_, index) => ({ position: index, media_type: 'image', ...(data[index] || {}) })));
  }, [data]);

  const handleSlideChange = (index, changes) => {
    setSlides((current) => current.map((slide, i) => i === index ? { ...slide, ...changes } : slide));
  };

  const handleSave = async () => {
    const invalidVideo = slides.some((slide) => slide.media_type === 'video' && (!slide.video_url || !slide.image_meta?.title || !slide.image_meta?.description));
    if (invalidVideo) {
      toast.error('Per ogni video inserisci URL, titolo SEO e descrizione SEO');
      return;
    }
    setSaving(true);
    try {
      await Promise.all(slides.map(({ id, position, media_type = 'image', image, video_url, image_meta }) => {
        const data = { position, media_type, image, video_url, image_meta };
        return id ? base44.entities.HomeSlide.update(id, data) : base44.entities.HomeSlide.create(data);
      }));
      await queryClient.invalidateQueries({ queryKey: ['home-slides'] });
      toast.success('Carosello Home aggiornato');
    } catch {
      toast.error('Impossibile salvare i contenuti');
    } finally {
      setSaving(false);
    }
  };

  return { slides, isLoading, saving, handleSlideChange, handleSave };
}